/* @ngInject */
export default class CashflowStatementCtrl {
    constructor(
        $sce,
        $scope,
        $state,
        Utility,
        $timeout,
        $rootScope,
        BuildingsService,
        FinancialsService,
        LocalStorageService,
        NotificationService,
        CashflowStatementDataService,
        AuthorizationService
    ) {
        this.$sce = $sce;
        this.$scope = $scope;
        this.$state = $state;
        this.Utility = Utility;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.BuildingsService = BuildingsService;
        this.FinancialsService = FinancialsService;
        this.LocalStorageService = LocalStorageService;
        this.NotificationService = NotificationService;
        this.CashflowStatementDataService = CashflowStatementDataService;
        this.AuthorizationService = AuthorizationService;

        this.init();
        this.activate();
    }

    init() {
        this._switchIsBusyLoading(true);

        this.isMonthlyView = true;
        this.isFilterActive = true;
        this.isYearFilterActive = false;
        this.filterYear = undefined;
        this.filterMonth = undefined;

        this.reportModelHeader = '';
        this.serviceData = undefined;
        this.isLoadingReport = false;
        this.selectedBuildingRef = '';
        this.selectedBuildingName = '';
        this.policyDocument = undefined;
        this.iframePaymentDocuments = '';
        this.previousMonth = { Date: '' };
        this.statusInformation = null;
        this.investmentStatment = undefined;

        this.isLoadingTransactionsForYear = {};
        this.isShowingYearlyTransactions = false;

        this.interestAccountCodes = ['41005', '12020'];

        this.financialsServiceData = undefined;
        this.webPaymentApprovalIndividual = undefined;
        this.today = this.Utility.getFormatedDate(new Date());
        this.selectedDate = this.Utility.getFormatedDate(new Date());
        this.selectedDateYear = this.Utility.getFormatedDate(new Date());

        this.stickableStyles = this.monthlyStyles;

        this._registerEventHandling();
    }

    _registerEventHandling() {
        this.$scope.$on('selected-building-changed', async (event, newValue) => {
            await this.onSelectedBuildingChanged(this, newValue);
        });

        this.$scope.$watch('cashflowStatementVm.isShowingYearlyTransactions', (newValue, oldValue) => {
            if (newValue) {
                this.CashflowStatementDataService.yearlyTransactions = {};
            }
        });

        this._registerClicks();
    }

    _registerClicks() {
        const $elements = angular.element('.list-inline.statement-inner .actualBudget-value');
        $elements.each((i, element) => {
            const $element = $(element);
            $element.on('click', (evt) => {
                this._removeSelected(true);
                const { target } = evt;

                const $selectDiv = $(target);
                if ($selectDiv.hasClass('actualBudget-value')) {
                    $selectDiv.addClass('selected');
                } else {
                    $selectDiv.closest('actualBudget-value').addClass('selected');
                }
            });
        });
    }

    _removeSelected(deselect = false) {
        const $elements = angular.element('.list-inline.statement-inner .actualBudget-value');

        $elements.each((i, element) => {
            const $element = $(element);
            if (!deselect) {
                $element.off('click');
            }
            if ($element.hasClass('selected')) {
                $element.removeClass('selected');
            } else {
                $element.closest('actualBudget-value').removeClass('selected');
            }
        });
    }

    openFinancials(page) {
        this.saveSelectedDate();
        this.$rootScope.$broadcast('navigate-changed', page, { date: this.filterMonth });
    }

    saveSelectedDate() {
        const selectedYear = moment(this.filterYear).toDate();
        const selectedMonth = moment(this.filterMonth).add(3, 'h').toDate();
        this.LocalStorageService.save('selectedReportYear', selectedYear);
        this.LocalStorageService.save('selectedReportMonth', selectedMonth);
    }

    async gotoOldFinancials() {
        const date = moment(this.filterMonth).format('MMM YYYY');
        let nav = `Monthly Financial Statements>${date}`;
        nav = encodeURI(nav);
        this.$state.go('documents', { nav });
    }

    isDesktop() {
        this.LocalStorageService.save('mediaDevice', 'mobile');
        const mdvice = this.LocalStorageService.retrieve('mediaDevice');
        if (mdvice == 'mobile') {
            return true;
        }
    }

    getBudgetIssueClass(isOverBudget, accountCode) {
        const budgetIssue = isOverBudget ? 'budget-issue' : 'no-budget-issue';
        return budgetIssue;
    }

    async filterByCurrentMonth() {
        this.isFilterActive = true;
        this.selectedDate = this.Utility.getFormatedDate(new Date());
        await this.getCashflowStatement();
    }

    async filterByMonth() {
        this.CashflowStatementDataService.cashflowData = undefined;
        this.CashflowStatementDataService.yearlyCashflowData = undefined;
        this.$timeout(async () => {
            if (this.filterMonth) {
                this.selectedDate = this.Utility.getFormatedDate(this.filterMonth);
                await this.getCashflowStatement();
                var temp = await this.FinancialsService.setReportURL(this.selectedBuildingRef, this.selectedDate);
                $("#mobileLink").attr("href", temp);
            }
        });
    }

    getAccountNameHtmlFromItem(item) {
        if (item.AccountCode == '43020' && item.AccountName.includes('Expenses')) {
            const replacementString = '<span style="color:red">(Expenses)</span>';
            const stringToReplace = 'Expenses';

            const accountname = item.AccountName.replace(stringToReplace, replacementString);

            return this.$sce.trustAsHtml(accountname);
        }

        if (item.Children && item.Children.length > 0) {
            const concatString = '<span class="glyphers glyphicon glyphicon-menu-down text-center glyphiconMobileResponsive"></span>';

            const accountname = item.AccountName.concat(" ", concatString);

            return this.$sce.trustAsHtml(accountname);
        }

        return item.AccountName;
    }

    async filterByYear() {
        this.filterMonth = '';
        this.serviceData.cashflowData = undefined;
        this.serviceData.yearlyCashflowData = undefined;
        this.selectedDateYear = this.Utility.getFormatedDate(this.filterYear);
        if (this.isMonthlyView) {
            await this.getFinancialMonths(this.selectedDateYear);
        } else {
            this.selectedDate = this.Utility.getFormatedDate(this.filterYear);
            await this.getYearlyCashflowStatement();
        }
    }

    async getReport() {
        this._switchIsBusyLoading(true);

        try {
            this.reportModelHeader = `${this.selectedBuildingName} - Cashflow Statement - ${moment(
                this.selectedDate
            ).format('MMM YYYY')}`;
            await this.FinancialsService.getReport(
                this.selectedBuildingRef,
                this.selectedDate,
                0,
                this.reportModelHeader
            );
        } catch (err) {
            this.NotificationService.error('Error Downloading Report');
        } finally {
            this._switchIsBusyLoading(false);
        }
    }



    async getAllReports() {
        this._switchIsBusyLoading(true);

        try {

            this.reportModelHeader = `${this.selectedBuildingName} - Cashflow Statement - ${moment(
                this.selectedDate
            ).format('MMM YYYY')}`;
            await this.FinancialsService.getAllReports(
                this.selectedBuildingRef,
                this.selectedDate,
                0,
                this.reportModelHeader
            );


        } catch (err) {
            this.NotificationService.error('Error Downloading Report');
        }

        finally {
            this._switchIsBusyLoading(false);
        }
    }


    async activate() {
        this.serviceData = this.CashflowStatementDataService;
        this.financialsServiceData = this.FinancialsService;
        this.selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();

        let buildingName = '';
        const userProfile = this.LocalStorageService.retrieve('userProfile');

        if (userProfile) {
            if (!this.selectedBuildingRef) {
                this.selectedBuildingRef = userProfile.BuildingProfiles[0].SchemeReference;
            }
            const selectedBuilding = userProfile.BuildingProfiles.find((building) => {
                return building.SchemeReference.toUpperCase().trim() === this.selectedBuildingRef.toUpperCase().trim();
            });

            if (selectedBuilding) {
                buildingName = selectedBuilding.SchemeName;
            }
        }

        await this.getFinancialYears(true);
        this.selectedBuildingName = buildingName;
        var temp = await this.FinancialsService.setReportURL(this.selectedBuildingRef, this.selectedDate);
        $("#mobileLink").attr("href", temp);
    }

    async getFinancialYears(isInit) {
        this._switchIsBusyLoading(true);

        try {
            await this.FinancialsService.getFinancialYears(this.selectedBuildingRef, this.today);
            if (isInit) {
                await this.getSelectedDate(true);
            } else {
                this.filterYear = this.FinancialsService.financialYears[
                    (await this.FinancialsService.financialYears.length) - 1
                ].WhenTo;
                this.selectedDateYear = this.Utility.getFormatedDate(this.filterYear);
                await this.getFinancialMonths(this.today);
            }
        } catch (err) {
            console.error(`Error while loading financial years\n${err}`);
        } finally {
            this._switchIsBusyLoading(false);
        }
    }

    async getFinancialMonths(date, isInit) {
        this._switchIsBusyLoading(true);
        try {
            await this.FinancialsService.getFinancialMonths(this.selectedBuildingRef, date || new Date());
            let selectedMonthIndex = -1;

            const selectedDateMonth = await this.FinancialsService.getSelectedMonth();

            if (selectedDateMonth) {
                if (this.FinancialsService.financialMonths && this.FinancialsService.financialMonths.length > 0) {
                    const foundMonth = this.FinancialsService.financialMonths.find((month, index) => {
                        const momentMonth = moment(month.WhenFrom);
                        if (momentMonth.isSame(selectedDateMonth, 'month')) {
                            selectedMonthIndex = index;
                            return true;
                        }
                    });

                    if (selectedMonthIndex > -1 && foundMonth) {
                        this.filterMonth = this.FinancialsService.financialMonths[selectedMonthIndex].WhenFrom;
                        this._filterOutFutureMonths();
                    }
                }
            } else if (date && isInit) {
                this.FinancialsService.financialMonths.filter(async (month, i) => {
                    const monthDateStr = month.WhenFrom.substr(0, 10);
                    const monthDate = moment(new Date(monthDateStr), 'YYYY-DD-MM');
                    const selectedMonth = await this.FinancialsService.getSelectedMonth();

                    if (monthDate.isSame(selectedMonth, 'month')) {
                        selectedMonthIndex = i;
                        return true;
                    }
                });

                if (selectedMonthIndex === -1) {
                    this.filterMonth = '';
                } else {
                    this.filterMonth = this.FinancialsService.financialMonths[selectedMonthIndex].WhenFrom;
                }
            } else if (isInit) {
                this.filterMonth = this.FinancialsService.financialMonths[
                    this.FinancialsService.financialMonths.length - 1
                ].WhenFrom;
            }
            if (this.filterMonth) {
                this.selectedDate = this.filterMonth;
                await this.getCashflowStatement();
            }
        } catch (err) {
            console.error(`Error while loading financial months\n${err}`);
        } finally {
            this._switchIsBusyLoading(false);
        }
    }

    async onSelectedBuildingChanged(event, schemeRef) {
        if (schemeRef && schemeRef['length'] > 2) this.selectedBuildingRef = schemeRef;
        else this.selectedBuildingRef = await this.BuildingsService.getSelectedBuildingRef();

        if (this.selectedBuildingRef && this.selectedBuildingRef.length > 2) {
            await this.activate();
        }
    }

    async getCashflowStatement() {
        this._switchIsBusyLoading(true);

        try {
            this.selectedDate = await this.FinancialsService.getSelectedDate(this.selectedDate);
            await this.CashflowStatementDataService.getCashflowStatement(this.selectedBuildingRef, this.selectedDate);

            await this.getFinancialState();
        } finally {
            this._switchIsBusyLoading(false);
            this._cleanUp();
        }
    }

    leviesReceivedSummary() {
        if (!this.CashflowStatementDataService.leviesRecievedSummary) {
            return {
                GrossLeviesRecieved: "0",
                TotalLegalFessPaid: "0",
                NetLeviesRecieved: "0"
            };
        }
        else
            return this.CashflowStatementDataService.leviesRecievedSummary;
    }

    shouldShowLeviesReceivedSummary() {
        if (
            this.leviesReceivedSummary().GrossLeviesRecieved == "0" &&
            this.leviesReceivedSummary().TotalLegalFessPaid == "0" &&
            this.leviesReceivedSummary().NetLeviesRecieved == "0"
        ) {
            return false;
        }
        else {
            return true;
        }
    }

    async getYearlyCashflowStatement() {
        this._switchIsBusyLoading(true);

        try {
            this.selectedDate = await this.FinancialsService.getSelectedDate(this.selectedDate);
            await this.CashflowStatementDataService.getYearlyCashflowStatement(
                this.selectedBuildingRef,
                this.selectedDate
            );
            this.$timeout(() => { });
        } catch (err) {
            console.error(`Error while loading yearly cashflow statement\n${err}`);
        } finally {
            this._switchIsBusyLoading(false);
        }
    }

    saveSelectedDate() {
        const selectedYear = moment(this.filterYear).toDate();
        const selectedMonth = moment(this.filterMonth).add(3, 'h').toDate();
        this.LocalStorageService.save('selectedReportYear', selectedYear);
        this.LocalStorageService.save('selectedReportMonth', selectedMonth);
    }

    saveSelectedDateWithMonth(month) {
        const selectedYear = moment(this.filterYear).toDate();
        const selectedMonth = moment(month).add(3, 'h').toDate();
        this.LocalStorageService.save('selectedReportYear', selectedYear);
        this.LocalStorageService.save('selectedReportMonth', selectedMonth);
    }

    async getSelectedDate(isInit) {
        const selectedDateYear = await this.FinancialsService.getSelectedYear();
        const selectedDateMonth = await this.FinancialsService.getSelectedMonth();

        if (isInit) {
            for (let i = 0; i < this.FinancialsService.financialYears.length; i++) {
                const yearRaw = this.FinancialsService.financialYears[i];

                if (selectedDateYear.isBetween(yearRaw.WhenFrom, yearRaw.WhenTo)) {
                    this.filterYear = this.FinancialsService.financialYears[i].WhenTo;
                    this.selectedDateYear = await this.Utility.getFormatedDate(this.filterYear);
                    break;
                }
            }

            const date = selectedDateYear ? selectedDateYear : new Date();
            await this.getFinancialMonths(date, true);
        }
    }

    closeTransaction(item, type, event) {
        this.$timeout(() => {
            const accountCode = item.AccountCode;
            this.CashflowStatementDataService.transactions[accountCode] = [];
            const element = angular.element(angular.element(event.currentTarget).parents(`#${type}-${accountCode}`)[0]);
            angular.element(element.removeClass('in'));
        });
    }
    async accounttabOpen(accCode) {
        if (accCode == "62900") this.openFinancials('wages-roll')
    }

    async accountClick(accountCode, event, type) {
        const element = angular.element(event.currentTarget)[0];
        const { className } = element;

        if (!className.includes('actualBudget-value') && !className.includes('clickable')) {
            this.CashflowStatementDataService.transactions[accountCode] = [];
            return;
        }

        switch (accountCode) {
            case '12000':
                break;
            case '12020':
                this._handleAccordionToggle(type, accountCode);
                await this.getTransactions(accountCode, true);
                break;
            case '12025':
                await this.showStatement(accountCode);
                break;
            case '12000':
            case '12050':
            case '13000':
                this.CashflowStatementDataService.transactions[accountCode] = [];
                break;
            case '12030':
            case '12035':
            case '12040':
            case '12045':
                await this.showStatement(accountCode);
                break;
            case '400000':
            case '400075':
            case '1':
                this.saveSelectedDate();
                angular.element('#nagNavigation').modal('show');
                break;
            case '41005':
                this._handleAccordionToggle(type, accountCode);
                await this.getTransactions(accountCode, true);
                break;
            case '62700':
                await this.showPolicy();
                break;
            case '62900':
                this._handleAccordionToggle(type, accountCode);
                await this.getTransactions(accountCode);
                //TODO: show Payslip
                //TODO: remove getTransactions(accountCode);
                break;
            default:
                if (accountCode.length === 5) {
                    this._handleAccordionToggle(type, accountCode);
                    await this.getTransactions(accountCode);
                }
        }
    }

    async accountClickYear(accountCode, event, type) {
        await this.getTransactionsForYear(accountCode);
        this._handleAccordionToggle(type, accountCode);
    }

    async getTransactions(accountCode, isInterest, selectedDate = null) {
        this.setIsLoadingTranstactions(accountCode, true);

        try {
            await this.CashflowStatementDataService.getTransactions(
                this.selectedBuildingRef,
                selectedDate ? selectedDate : this.selectedDate,
                accountCode,
                isInterest
            );
        } catch (err) {
            console.error(`Error while loading transactions\n${err}`);
        } finally {
            this.setIsLoadingTranstactions(accountCode, false);
        }
    }

    async getTransactionsForYear(accountCode, selectedDate = null) {
        this.setIsLoadingTranstactions(accountCode, true);

        try {
            const payload = {
                accountCode,
                schemeRef: this.selectedBuildingRef,
                date: selectedDate ? selectedDate : this.selectedDate
            };

            await this.CashflowStatementDataService.getTransactionsForYear(payload);
        } catch (err) {
            console.error(`Error while loading transactions for year\n${err}`);
        } finally {
            this.setIsLoadingTranstactions(accountCode, false);
        }
    }

    setIsLoadingTranstactions(accCode, isBusy) {
        this.$timeout(() => {
            if (!this.isLoadingTransactions) {
                this.isLoadingTransactions = {};
            }

            this.isLoadingTransactions[accCode] = isBusy;
        });
    }

    setIsLoadingTranstactionsForYear(accCode, isBusy) {
        this.$timeout(() => {
            if (!this.isLoadingTransactionsForYear) {
                this.isLoadingTransactionsForYear = {};
            }

            this.isLoadingTransactionsForYear[accCode] = isBusy;
        });
    }

    navigateToLevyRoll() {
        this.$timeout(() => {
            angular.element('#nagNavigation').modal('hide');

            angular.element('#nagNavigation').on('hidden.bs.modal', () => {
                this.$rootScope.$broadcast('navigate-changed', 'levy-roll', { date: this.filterMonth });
            });
        });
    }

    async showStatement(accountCode) {

        this.investmentStatment = {
            currentAttachment: {
                documentsUrl: ''
            },
            attachments: []
        };

        try {
            const results = await this.CashflowStatementDataService.loadStatements(
                this.selectedBuildingRef,
                this.filterMonth,
                accountCode
            );
            this.investmentStatment.attachments = results.map((file) => {
                const attachmentUrl = `${pretorOnlineUrl}${pretorOnlineUrl.endsWith('/')
                    ? ''
                    : '/'}documents/byid/${file.Id}/?handleNotFound=false`;
                file.documentsUrl = this.$sce.trustAsResourceUrl(attachmentUrl);

                return file;
            });

            this.investmentStatment.currentAttachment = this.investmentStatment.attachments[0];
        } catch (err) {
            console.error(`Error while loading statement\n${err}`);
            this.investmentStatment = {
                currentAttachment: {
                    documentsUrl: 'http://www.notfount.co.za/error'
                },
                attachments: []
            };
        } finally {
            this.$timeout(() => {
                angular.element('#investmentBankStatementQueryModal').modal('show');
            });
        }
    }

    async showPolicy() {
        this.policyDocument = {
            currentAttachment: {
                documentsUrl: ''
            },
            attachments: []
        };

        try {
            const results = await this.CashflowStatementDataService.loadPolicyDocuments(this.selectedBuildingRef);
            this.policyDocument.attachments = results.map((file) => {
                const attachmentUrl = `${pretorOnlineUrl}${pretorOnlineUrl.endsWith('/')
                    ? ''
                    : '/'}documents/byid/${file.Id}/?handleNotFound=false`;
                file.documentsUrl = this.$sce.trustAsResourceUrl(attachmentUrl);

                return file;
            });

            this.policyDocument.currentAttachment = this.policyDocument.attachments[0];

            this.$timeout(() => angular.element('#policyDocumentModal').modal('show'));
        } catch (err) {
            this.policyDocument = {
                currentAttachment: {
                    documentsUrl: 'http://www.notfound.co.za/error'
                },
                attachments: []
            };
        } finally {
        }
    }

    getInvestmentAttachmentPath(statementAttachment) {
        this.$timeout(() => {
            if ('CorrelationId' in this.investmentStatment.currentAttachment) {
                this.investmentStatment.currentAttachment = this.investmentStatment.attachments.find((attachment) => {
                    return attachment.CorrelationId === statementAttachment.CorrelationId;
                });
            } else {
                this._mapStatements();
                this.investmentStatment.currentAttachment = this.investmentStatment.attachments.find((statements) => {
                    return statements.Id === statementAttachment.Id;
                });
            }
        });
    }

    getPolicyAttachmentPath(id) {
        this.policyDocument.currentAttachment = this.policyDocument.attachments.find((attachment) => {
            return attachment.CorrelationId === id;
        });
    }

    async showPayment(payment) {
        this.webPaymentApprovalIndividual = undefined;
        this.iframePaymentDocuments = undefined;
        if (typeof payment != 'undefined' && payment != null) {
            this.webPaymentApprovalIndividual = payment;

            for (let j = 0; j < this.webPaymentApprovalIndividual.Attachments.length; j++) {
                if (this.webPaymentApprovalIndividual.Attachments[j].IsInvoice) {
                    const { Path, DocumentExtension } = this.webPaymentApprovalIndividual.Attachments[j];
                    const pathToLowerCase = Path.toLowerCase();
                    let url = '';

                    if (!pathToLowerCase.endsWith(`${DocumentExtension.toLowerCase()}`)) {
                        url = `${Path}${DocumentExtension ? DocumentExtension.toLowerCase() : ''}`;
                    } else {
                        url = Path;
                    }

                    this.iframePaymentDocuments = this.$sce.trustAsResourceUrl(url);
                }
            }
        } else {
            return;
        }

        angular.element('#paymentViewModal').on('show.bs.modal', (evt) => {
            if (!!this.iframePaymentDocuments) {
                this.getInvoicePath(0);
            }
        });
        this.$timeout(() => {
            angular.element('#paymentViewModal').modal('show');
        });
        return;
    }

    async showBankStatement(accountCode, date, lineMemo) {
        try {
            date = date.split('-');
            date[date.length - 1] = '01';
            date = date.join('-');
            const results = await this.CashflowStatementDataService.getInterestTransactionDetails(accountCode, date);

            await this.previewBankStatement(results, lineMemo);
        } catch (error) {
            this.investmentStatment = {
                currentAttachment: {
                    documentsUrl: 'http://www.notfount.co.za/error'
                },
                attachments: []
            };
            console.error(`Error while loading Bank Statement: `, error);
            this.NotificationService.error(`Error loading back statement(s): ${accountCode}`);
        } finally {
        }
    }

    async previewBankStatement(records, lineMemo) {
        this.investmentStatment = {};

        try {
            this.investmentStatment = {
                currentAttachment: {
                    documentsUrl: ''
                },
                attachments: []
            };
            if (lineMemo) {
                let matched = false;
                for (var i = 0; i < records.length; i++) {
                    if (lineMemo.includes(records[i].Description)) {
                        this._mapStatements(i);
                        matched = true;
                    }
                }

                // Own-bank interest memos do not carry the account number, so show what the backend returned.
                if (!matched) {
                    this._mapStatements();
                }
            } else {
                this._mapStatements();
            }

            this.$timeout(() => angular.element('#investmentBankStatementQueryModal').modal('show'));
        } catch (error) {
            const msg = 'Error loading statement';
            console.error(`${msg}`, error);
            this.investmentStatment = {};
            this.NotificationService.error(msg);
        }

        return;
    }

    getInvoicePath(index) {
        this.iframePaymentDocuments = undefined;
        const { Path, DocumentExtension } = this.webPaymentApprovalIndividual.Attachments[index];
        const pathToLowerCase = Path.toLowerCase();

        let url;
        if (!!DocumentExtension && !pathToLowerCase.endsWith(`${DocumentExtension.toLowerCase()}`)) {
            url = `${Path}${DocumentExtension}`;
        } else {
            url = Path;
        }

        this.iframePaymentDocuments = this.$sce.trustAsResourceUrl(url);
    }

    isInterest(accountCode) {
        const isInterest = this.interestAccountCodes.includes(accountCode);
        return isInterest;
    }

    _handleAccordionToggle(type, accountCode) {
        const $accordion = angular.element(`#${type}-${accountCode}`);
        const isExpanded = $accordion.hasClass('in');

        if (!isExpanded) {
            this.$timeout(() => {
                $accordion.collapse('show');
            });
        }
    }

    _mapStatements(index = 0) {
        let { statements } = this.CashflowStatementDataService;
        statements = statements.map((statement) => {
            return {
                ...statement,
                documentsUrl: this._idToFilePath(statement.Id)
            };
        });

        const Attachments = statements;
        this.investmentStatment = {
            Attachments,
            attachments: statements,
            currentAttachment: statements[index]
        };
    }

    _idToFilePath(id) {
        const path = `${pretorOnlineUrl}${pretorOnlineUrl.endsWith('/')
            ? ''
            : '/'}documents/byid/${id}/?handleNotFound=false`;

        return this.$sce.trustAsResourceUrl(path);
    }

    get monthsToDate() {
        if (!!!this.filterMonth) {
            return;
        }

        let results;
        const selectedYearMoment = moment(this.filterMonth);
        const selectedYear = this.FinancialsService.financialYears.find((financialYear) => {
            const { WhenTo, WhenFrom } = financialYear;
            const whenToMoment = moment(WhenTo);
            const whenFromMoment = moment(WhenFrom);

            let isFound =
                whenFromMoment.isSameOrBefore(selectedYearMoment) && whenToMoment.isSameOrAfter(selectedYearMoment);

            return isFound;
        });

        if (selectedYear) {
            const { WhenFrom } = selectedYear;
            const whenFromMoment = moment(WhenFrom);
            results = `${whenFromMoment.format('MMM YYYY')} - ${selectedYearMoment.format('MMM YYYY')}`;
        }

        return results;
    }

    get monthlyStyles() {
        return `
		top: 6.9em;
		left: 4.93em;
		width: 91.74%;
		z-index: 10;
		position: fixed;
		background-color: #e8e8e8;
		`;
    }

    get yearlyStyles() {
        return `
		top: 7.9em;
		left: 4.93em;
		width: 91.74%;
		z-index: 10;
		position: fixed;
		background-color: #e8e8e8;
		`;
    }

    async changeView() {
        this.isMonthlyView = !this.isMonthlyView;
        if (!this.isMonthlyView) {
            this.isYearFilterActive = true;
            await this.getYearlyCashflowStatement();
            this.stickableStyles = this.yearlyStyles;
        } else {
            this.isYearFilterActive = false;
            await this.getCashflowStatement();
            this.stickableStyles = this.monthlyStyles;
        }
    }

    async level5Selected(item, $event) {
        angular.element('div.highlighted').each((index, element) => {
            angular.element(element).removeClass('highlighted');
        });

        let shouldShow = false;

        if ($event.currentTarget.id === 'closeTransactions') {
            let $element;

            if (angular.element($event.target)[0].tagName === 'SPAN') {
                $element = angular.element(angular.element($event.target).parent()[0]).addClass('highlighted');
            } else {
                $element = angular.element($event.target).addClass('highlighted');
            }

            const cssSelector = `[id*=-${item.AccountCode}-body].panel-collapse`;
            const $target = angular.element(cssSelector);

            $target.collapse('hide');
            this.previousMonth.Date = '';
            $element.removeClass('highlighted');
        }

        switch (item.AccountCode) {
            case '12000':
            case '12020':
            case '12025':
            case '12050':
            case '13000':
            case '62700':
                break;
            case '12025':
            case '12030':
            case '12035':
            case '12040':
            case '12045':
            case '41005':
                shouldShow = true;
            case '400000':
            case '400075':
            case '1':
                var date = angular.element($event.target)[0].id;
                if (typeof date !== 'undefined') {
                    this.saveSelectedDateWithMonth(date);
                    this.previousMonth.Date = date;
                    this.$rootScope.$broadcast('navigate-changed', 'levy-roll');
                }
                break;
            case '62700':
                await this.showPolicy();
                break;
            default:
                if (item.AccountCode.length === 5) {
                    shouldShow = true;
                }
        }

        if (shouldShow) {
            this._handleShowDetails($event, item);
        }
    }

    async getFinancialState() {
        const type = 0;
        const schemeRef = this.selectedBuildingRef;
        const momentDate = moment(this.selectedDate, 'YYYY-MM-DD');
        const formattedDate = momentDate.format('YYYY-MM-DD');
        const date = `${formattedDate.substr(0, 8)}01`;

        this._switchIsBusyLoading(true);
        try {
            const results = await this.FinancialsService.getFinancialState(schemeRef, date, type);

            const { status, message } = results;
            this.statusInformation = message;
        } catch (error) {
            this.NotificationService.error('Error loading cashflow statement status');
        } finally {
            this._switchIsBusyLoading(false);
        }
    }

    getTarget(type, item) {
        let target = '';

        if (item.Children && item.Children.length > 0) {
            target = `#${type}-${item.AccountCode}-body`;
        }

        return target;
    }

    _handleShowDetails($event, item) {
        let $element;
        if (angular.element($event.target)[0].tagName === 'SPAN') {
            $element = angular.element(angular.element($event.target).parent()[0]).addClass('highlighted');
        } else {
            $element = angular.element($event.target).addClass('highlighted');
        }
        const date = angular.element($event.target)[0].id;
        if (typeof date !== 'undefined') {
            const cssSelector = `[id*=-${item.AccountCode}-body].panel-collapse`;
            const $target = angular.element(cssSelector);
            const previousDateStr = moment(this.previousMonth.Date).format('DD/MM/YYYY');
            const currentDateStr = moment(date).format('DD/MM/YYYY');
            const previousDate = moment(previousDateStr);
            const currentDate = moment(currentDateStr);
            const shouldHide = previousDate.isSame(currentDate);
            if (shouldHide) {
                $target.collapse('hide');
                this.previousMonth.Date = '';
                $element.removeClass('highlighted');
            } else {
                this.getTransactions(item.AccountCode, null, date);
                $target.collapse('show');
                this.previousMonth.Date = date;
            }
        }
    }

    _switchIsBusyLoading(flag) {
        this.$timeout(() => {
            this.isLoading = flag;
        });
    }

    _switchIsShowingYearlyTransactions(flag) {
        this.$timeout(() => {
            this.isShowingYearlyTransactions = flag;
        });
    }

    _cleanUp() {
        this.$timeout(() => {
            angular.element('[data-target="#administrative-400000"]').attr('data-target', '');

            this._registerClicks();
        }, 800);
    }

    allowAction(actionName) {
        return this.AuthorizationService.isAuthorized(actionName);
    }

    _filterOutFutureMonths() {
        const today = new Date();
        const formatedDate = moment(today).format('YYYY MMMM');
        const currentYear = formatedDate.split(' ')[0];
        const currentMonth = formatedDate.split(' ')[1];

        let foundIndex = -1;
        const found = this.FinancialsService.financialMonths.find((month, index) => {
            const fields = month.FriendlyNameMonth.split(' ');
            const yearStr = fields[1];
            const monthStr = fields[0];
            const found = currentYear === yearStr && currentMonth === monthStr;

            if (found) {
                foundIndex = index;
            }
            return found;
        });

        if (found && foundIndex > -1) {
            const filteredMonths = this.FinancialsService.financialMonths.filter(
                (month, index) => index < foundIndex + 1
            );

            if (filteredMonths && filteredMonths.length < this.FinancialsService.financialMonths.length) {
                this.FinancialsService.financialMonths = filteredMonths;
            }
        }
    }
}
